export default "__VITE_ASSET__4942db69__"